import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import DynamicFieldLabel from "./DynamicFieldLabel";
import FieldAlias from "../enums/FieldAlias";
import OrganizationUrlComponent from "shared/form/renderer/components/organizationUrl";
import FormUrlField from "shared/form/fields/urlField";

/**
 * @name UrlFieldWrapper
 * @interface DynamicFieldConfigType
 * @param props
 * @constructor
 */
export default function UrlFieldWrapper(props: DynamicFieldConfigType) {
  if (props.schemaObj.alias === FieldAlias.ORGANIZATION_URL) {
    return <OrganizationUrlComponent schemaObj={props.schemaObj} validationFn={props.validationFn} />;
  }

  return (
    <React.Fragment>
      <FormUrlField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        disabled={props.schemaObj.disabled}
        required={props.schemaObj.mandatory}
        validate={props.validationFn}
        placeholder={props.schemaObj.placeholderLabel}
        conflictValue={props.schemaObj.conflictValue}
        fullWidth={props.schemaObj.fullWidthView}
        indented={props.schemaObj.indented}
      />
    </React.Fragment>
  );
}
